import React, { useState } from "react";
import { TouchableOpacity, Text, StyleSheet, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { FlatList } from "react-native-gesture-handler";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { AppScreens } from "../../screens/Utility/AppScreens";
import NoDataFound from "../NoDataFound";
import { AppImages } from "../../utility/AppImages";
import ImageComponent from "../ImageComponent";
import Avatar from "../choose-avatar-components/Avatar";

type User = {
  userID: string;
  profilePicture: string;
  isSelected: number;
};

type UserListingProps = {
  title: string;
  userResult: User[];
  userData: any;
  userResultEmpty: boolean;
};

const UserListing: React.FC<UserListingProps> = ({
  title = "",
  userResult,
  userData,
  userResultEmpty,
}) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const defaultProfile =
    "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg";
  return (
    <View style={{ paddingVertical: 12 }}>
      <Text style={[AppFontStyle.BOLD_ANYBODY_14, { color: AppColors.white }]}>
        {title}
      </Text>

      {userResultEmpty ? (
        // <Text
        //   style={[
        //     AppFontStyle.REGULAR_ANYBODY_14,
        //     {
        //       color: AppColors.white,
        //       flex: 1,
        //       alignSelf: "center",
        //       marginTop: 20,
        //     },
        //   ]}
        // >
        //   No Record Found
        // </Text>
        <NoDataFound marginTop={20} />
      ) : (
        <FlatList
          data={userResult}
          style={{ gap: 8 }}
          key={
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 3
              : 5
          }
          numColumns={
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 3
              : 5
          }
          columnWrapperStyle={{
            flex: 1,
            gap: 8,
          }}
          renderItem={({ item, index }) => (
            <TouchableOpacity
              style={{
                flexDirection: "row",
                flex:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? 1 / 3
                    : 1 / 5,
                paddingVertical: 10,
                marginBottom: 8,
                gap: 5,
              }}
              onPress={() => {
                // const username = item.ChallengeeID ? item.ChallengeeID : item.ChallengerID
                if (userData.username === item.userID) {
                  navigateToScreen(navigation, AppScreens.Profile);
                } else {
                  navigateToScreen(navigation, AppScreens.UserProfile, {
                      username: item.userID,
                    });
                }
              }}
            >
              {/* <ImageComponent
                url={
                  item?.profilePicture
                    ? item?.profilePicture
                    : AppImages.icProfilePlaceHolder
                }
                style={[
                  {
                    resizeMode: "contain",
                    width: 49,
                    height: 49,
                    borderRadius: "50%",
                  },
                ]}
              /> */}
              <View
                style={[
                  {
                    resizeMode: "contain",
                    width: 49,
                    height: 49,
                    borderRadius: "50%",
                  },
                ]}
              >
                <Avatar
                  src={
                    item.profilePicture ? item.profilePicture : defaultProfile
                  }
                  variant="pastSmallPlayer"
                />
              </View>
              <View
                style={{
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    { color: AppColors.white },
                  ]}
                >
                  {item.userID}
                </Text>
                {/* <Text
                                                    numberOfLines={2}
                                                    style={[AppFontStyle.REGULAR_ANYBODY_14, {
                                                        color: AppColors.grayColor_505050, flex: 1, flexWrap: 'wrap'
                                                    }]}>
                                                    {`gamer ID \nAvailable`}
                                                </Text> */}
              </View>
            </TouchableOpacity>
          )}
        />
      )}
    </View>
  );
};

export default UserListing;
